import { Outlet } from 'react-router-dom';

import { Analytics } from './analytics';
import { AutomationStatusBanner } from './automation-status-banner';
import { ChannelsSection } from './channels-section';
import { GeneralRecommendation } from './general-recommendations';

export function Channels() {
  return (
    <>
      <AutomationStatusBanner />
      <Analytics />
      <GeneralRecommendation />
      <ChannelsSection />
      <Outlet />
    </>
  );
}
